export const ShippingTypeEnum = {
  PAC: 'PAC',
  SEDEX: 'SEDEX',
  PAC_MINI: 'PACMINI',
  OWN_DELIVERY: 'OWN_DELIVERY'
}
